const stringToCamelCase = (str) => {
    return str
        .replace(/\s+/g, '')
        .replace(/\b\w/g, (match) => match.toUpperCase());
};
export default stringToCamelCase;
